import { useCallback, useEffect, useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { fetchAllPhotos } from "../../../api";

export default function ImageSearch({ onSelect }) {
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const doSearch = useCallback(async () => {
    if (!search.trim()) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const data = await fetchAllPhotos(20, 0, { q: search });
      setResults(data?.results || data || []);
    } catch (e) {
      console.error("Search failed:", e);
    }
    setLoading(false);
  }, [search]);

  useEffect(() => {
    const t = setTimeout(doSearch, 300);
    return () => clearTimeout(t);
  }, [search, doSearch]);

  return (
    <div className="image-search">
      <div className="search-icon">
        <MagnifyingGlassIcon className="icon" />
      </div>
      <input
        type="text"
        placeholder="Search image by filename or ID..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="search-input"
      />
      {loading && (
        <div className="search-loading">
          <span className="loading-pulse" />
        </div>
      )}
      {results.length > 0 && (
        <div className="search-results">
          {results.map((img) => (
            <div
              key={img.image_id}
              className="search-result"
              onClick={() => {
                onSelect(img);
                setSearch("");
                setResults([]);
              }}
            >
              <span className="result-filename">{img.filename}</span>
              <span className={`result-status status-${img.status}`}>{img.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
